module.exports = __webpack_public_path__ + "static/media/20.061.b0898c81.webp";